mod.modules.define("BaseAnalytics", function(fn) {

 //   fn.prototype.init = function (params) {
	//	this.category = "Default";
	//};

	//fn.prototype.trackPage = function(name) {
	//	name = name || "Untitled";

	//	_waq.push([
	//		'_trackPageView',
	//		{
	//			category: this.category,
	//			name: name
	//		}
	//	]);
	//};

	//fn.prototype.trackAction = function(actionCategory, name, value) {
	//	actionCategory = actionCategory || "Undefined";

	//	var data = {
	//		category: actionCategory
	//	};

	//	if (name) {
	//		data.name = name;
	//	}

	//	if (value) {
	//		data.value = value;
	//	}

	//	_waq.push(['_trackAction', data]);
	//};

	//fn.prototype.observables = {
	//    "search - symbol": function (term) {
	//		this.trackAction("Search", "Symbol");
	//	}
	//};

});